import { Pipe, PipeTransform } from '@angular/core';
import { StatusPill } from '../../../models/shared/status-pill';

@Pipe({
  name: 'memberActiveStatusPill',
  standalone: true
})
export class MemberActiveStatusPillPipe implements PipeTransform {
  transform(active: boolean): StatusPill {
    return active
      ? new StatusPill(1, $localize`Active`, '#0D5D4B', '#E8F3F1')
      : new StatusPill(2, $localize`Inactive`, '#666666', '#F7F7F7');
  }
}
